export function loadImage(src) {
    return new Promise((resolve) => {
        const image = document.createElement('img')
        image.src = src

        if (image.complete && image.naturalWidth) {
            resolve(image)
        } else {
            image.addEventListener('load', () => resolve(image))
        }
    })
}

export function loadSvg(src) {
    return new Promise((resolve, reject) => {
        fetch(src)
            .then(response => {
                if (response.ok && response.headers.get('Content-Type') === 'image/svg+xml') {
                    return response.text()
                }

                reject(response.status)
                return null
            })
            .then(text => {
                const parser = new DOMParser()
                const svg = parser.parseFromString(text, 'image/svg+xml').querySelector('svg')
                resolve(svg)
            })
    })
}



// WEBPACK FOOTER //
// ./app/theme/js/utility/image.js